import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import {
  getFindHighlightsKey,
  getFindLatestHighlightsKey,
  getHighlightKey,
} from './highlights.keys';
import { findHighlights, findLatestHighlights, getHighlightById } from './highlights.repository';
import { AdminHighlightOutput, HighlightOutput } from './highlights.types';

export const DEFAULT_LATEST_HIGHLIGHTS_LIMIT = 3;

export const useFindLatestHighlights = (
  limit: number = DEFAULT_LATEST_HIGHLIGHTS_LIMIT,
  options?: UseDataQueryOptions<HighlightOutput[]>,
) =>
  useDataQuery<HighlightOutput[]>(
    {
      queryKey: getFindLatestHighlightsKey(limit),
      queryFn: async () => {
        const response = await findLatestHighlights(limit);

        if (!response.ok || !response.data) {
          throw { response };
        }

        return response.data;
      },
    },
    { retry: false, ...options },
  );

export const useFindHighlights = (options?: UseDataQueryOptions<AdminHighlightOutput[]>) =>
  useDataQuery<AdminHighlightOutput[]>(
    {
      queryKey: getFindHighlightsKey(),
      queryFn: async () => {
        const response = await findHighlights();

        if (!response.ok || !response.data) {
          throw { response };
        }

        return response.data;
      },
    },
    options,
  );

export const useHighlight = (highlightId: string, options?: UseDataQueryOptions<HighlightOutput>) =>
  useDataQuery<HighlightOutput>(
    {
      queryKey: getHighlightKey(highlightId),
      queryFn: async () => {
        const response = await getHighlightById(highlightId);

        if (!response.ok || !response.data) {
          throw { response };
        }

        return response.data;
      },
    },
    options,
  );
